export const getActiveColorInGroup = (state) => {
  let showSettingGroupId = state["Settings"]["showSettingGroupId"];
  if (showSettingGroupId) {
    let settings = state["Settings"]["settings"];
    let activeGroup = settings.filter(
      (item) => showSettingGroupId === item.id
    )[0];
    return activeGroup ? activeGroup["infoActiveElement"] : null;
  }
  return null;
};
export const getListColorInGroup = (state) => {
  let showSettingGroupId = state["Settings"]["showSettingGroupId"];
  if (showSettingGroupId) {
    let settings = state["Settings"]["settings"];
    let activeGroup = settings.filter(
      (item) => showSettingGroupId === item.id
    )[0];
    return activeGroup ? activeGroup["values"] : [];
  }
  return [];
};

export const getActiveParams = (state) => {
  let tempArray = [];
 
  state["Settings"]["settings"].map((section) => {
    tempArray.push({ name: section.name, value: section.infoActiveElement?.name || '' });
  });
  return tempArray;
};

export const getParamsSaveConfiguration = ({ ...state }) => {
  const Settings = state["Settings"]
  return { Settings };
};

export const getInitConfiguration = ({ ...state }) => {
  const initConfig = state["Settings"]['initConfig']
  return { initConfig }
}

// Поточний тип лодки, який записується при INIT_PLAYCANVAS_SETTINGS
export const getCurrentBoatType = (state) => state["Settings"]["boatType"] || null;

export const getModal = (nameModal) => ({...state}) => {
  const modal = state.modals[nameModal];

  return modal
}